import { TipoRelatorio } from './../modal-exportacao/tipo-relatorio.enum';

export class ConfiguracaoModalExportacao {

  url?: string;
  filtro?: any;
  tipoRelatorio?: TipoRelatorio;
}
